<template>
  <gg-card>
    <gg-card-header>Change Password</gg-card-header>
    <gg-card-text>
      <v-form>
        <v-row>
          <v-col cols="12" md="4">
            <compact-password
              outlined
              charset="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMOPRSTUVWXYZ0123456789_"
              autocomplete="new-password"
              label="New Password"
              v-validate="'required|min:8'"
              data-vv-name="password"
              data-vv-as="Password"
              :error-messages="errors.collect('password')"
              with-generator
              v-model="password.newPassword"
            />
          </v-col>
        </v-row>
        <gg-btn
          class="mt-2 ml-0"
          @click="changePassword"
          :loading="loading"
        >
          Change Password
        </gg-btn>
      </v-form>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions } from 'vuex'
import PasswordMixin from '@/mixins/passwordForm'
import CompactPassword from '@/components/Common/password/CompactPassword'

export default {
  name: 'ServerPassword',
  mixins: [PasswordMixin],
  components: {
    CompactPassword
  },
  methods: {
    ...mapActions(['setHostingPassword', 'reportError', 'reportSuccess']),
    reset () {
      this.password.newPassword = ''
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
  },
}
</script>
